import React from "react";
import icon_bundle from "assets/img/icons/icons-bundle.svg";
import "assets/img/icons/icons-bundle.css";

class IconComponent extends React.Component {
  onClick = () => {
    const { onClick } = this.props;

    if (onClick) {
      onClick();
    }
  };

  renderSVG() {
    const { active, icon } = this.props;
    return (
      <svg
        className={`icon icons_${icon} ${active ? "active" : ""} ${this.props.className || ""}`}
        onClick={this.onClick}
      >
        <use xlinkHref={`${icon_bundle}#${icon}`} />
      </svg>
    );
  }

  render() {
    const { children } = this.props;
    if (children) {
      return (
        <div className="relative inline-block">
          {this.renderSVG()}
          <span className="icon_inner">{children}</span>
        </div>
      );
    }
    return this.renderSVG();
  }
}

export { IconComponent };
